import { Component, TemplateRef, ViewChild } from '@angular/core';
import { SpinnerComponent } from "../../layout/spinner/spinner.component";
import { LanguageService } from 'src/app/services/language/language.service';
import { ToastrService } from 'ngx-toastr';
import { PostsService } from 'src/app/services/posts/posts.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PostModalComponent } from './post-modal/post-modal.component';
import {environment} from '../../../../environments/environment'
import { HttpClient } from '@angular/common/http';
@Component({
  selector: 'app-posts',
  imports: [SpinnerComponent, CommonModule, FormsModule],
  templateUrl: './posts.component.html',
  styleUrls: ['./posts.component.css']
})
export class PostsComponent {

  // data from backend
  data: { items: any[], pagination: any } = { items: [], pagination: null };
  load = false;
  loaddata = false;
  currentLang = 'ge';
  loadDeleteId: number | null = null;

  page: number = 1;
  perPage: number = 20;

  selectedItems: any[] = [];
  selectedItem: number = 0;

  @ViewChild('scrollTarget') scrollTarget: any;

  selectedPost: any = null;
  @ViewChild('postFormModal') pageFormModalTemplate!: TemplateRef<any>;
  @ViewChild('postCatalogFormModal') postCatalogFormModal!: TemplateRef<any>;

  domain = 'https://sca.ge/';
  search: string = '';

  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';

  constructor(
    private langService: LanguageService,
    private ToastrService: ToastrService,
    private PostsService: PostsService,
    private modalService: NgbModal,
    private http: HttpClient
  ) {
    this.currentLang = this.langService.getLanguage();

    this.langService.currentLanguage$.subscribe((lang) => {
      this.currentLang = lang;
      this.page = 1;
      this.getListPages();
    });

    this.getListPages();
  }

  // Dropdown: list ტიპის გვერდების ჩამოტანა
  getListPages() {
    this.load = true;

    this.PostsService.getListPages({ list_pages: 1 }).subscribe(
      (res: any) => {
        this.load = false;
        console.log(res)
        const payload = res?.data ?? res?.items ?? res;
        this.selectedItems = Array.isArray(payload) ? payload : [];

        if (this.selectedItems.length > 0) {
          // Prefer menu_page = 161 (სიახლეები) if it exists
          const preferred = this.selectedItems.find((x: any) => Number(x?.menu_page) === 161);
          const first = preferred || this.selectedItems[0];

          this.selectedItem = Number(first?.menu_page ?? 0) || 0;
          this.page = 1;
          this.getPageByItems();
        }

        window.scrollTo({ top: 0, behavior: 'smooth' });
      },
      (err: any) => {
        console.error(err);
        this.load = false;
      }
    );
  }

  // სიახლეების ჩამოტანა menu_page-ს მიხედვით
  getPageByItems() {
    const menuPage = Number(this.selectedItem) || 0;
    if (!menuPage) return;

    this.loaddata = true;

    const params = {
      menu_page: menuPage,
      lang: this.currentLang,
      page: this.page,
      limit: this.perPage,
      q: this.search || ''
    };

    this.PostsService.getPageByItems(params).subscribe(
      (res: any) => {
        this.data.items = res.items || [];
        this.data.pagination = res.pagination;
        this.loaddata = false;

        setTimeout(() => {
          if (this.scrollTarget?.nativeElement) {
            this.scrollTarget.nativeElement.scrollIntoView({ behavior: 'smooth' });
          }
        }, 50);
      },
      (err: any) => {
        console.error(err);
        this.loaddata = false;
      }
    );
  }

  // Dropdown არჩევისას
  onMenuChange(value?: any) {
    if (value !== undefined) {
      this.selectedItem = Number(value) || 0;
    } else {
      this.selectedItem = Number(this.selectedItem) || 0;
    }

    this.page = 1;
    this.getPageByItems();
  }

  // Pagination
  changePage(newPage: number) {
    if (!this.data.pagination) return;

    if (newPage < 1 || newPage > this.data.pagination.last_page) return;

    this.page = newPage;
    this.getPageByItems();
  }

  // Sorting
  sortData(column: string) {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }

    if (this.data.items?.length) {
      this.data.items = [...this.data.items].sort((a, b) => {
        const valueA = a[column];
        const valueB = b[column];
        if (valueA == null) return 1;
        if (valueB == null) return -1;
        if (valueA < valueB) return this.sortDirection === 'asc' ? -1 : 1;
        if (valueA > valueB) return this.sortDirection === 'asc' ? 1 : -1;
        return 0;
      });
    }
  }

  getFullImageUrl(imagePath: string): string {
    if (!imagePath) return '';
    if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) return imagePath;
    return `https://api.sca.ge/storage/${imagePath.replace(/^\/+/, '')}`;
  }

  getMainImageUrl(item: any): string {
    const value = item?.main_image;

    if (!value) return '';

    // Newer API may return object: { url, ... }
    if (typeof value === 'object') {
      return (value?.url || '').toString();
    }

    return value.toString();
  }

  hasDisplayImage(item: any): boolean {
    const url = this.getMainImageUrl(item).trim().toLowerCase();
    if (!url) return false;

    const clean = url.split('?')[0].split('#')[0];
    const ext = clean.includes('.') ? (clean.split('.').pop() || '') : '';

    return ['jpg', 'jpeg', 'png', 'webp', 'gif', 'bmp', 'svg'].includes(ext);
  }

  // Open modals
  openPost() {
    this.selectedPost = null;

    const modalRef = this.modalService.open(PostModalComponent, { size: 'lg', windowClass: 'custom-modal' });

    modalRef.componentInstance.selectedItem = this.selectedItem;
    modalRef.componentInstance.selectedItems = this.selectedItems;

    modalRef.componentInstance.closeModal.subscribe(() => {
      modalRef.close();
      this.getPageByItems();
      this.selectedPost = null;
    });
  }

  edit(data: any) {
    this.selectedPost = data;

    const modalRef = this.modalService.open(PostModalComponent, { size: 'lg', windowClass: 'custom-modal' });

    modalRef.componentInstance.initialData = data;
    modalRef.componentInstance.selectedItem = this.selectedItem;
    modalRef.componentInstance.selectedItems = this.selectedItems;

    modalRef.componentInstance.closeModal.subscribe(() => {
      modalRef.close();
      this.getPageByItems();
      this.selectedPost = null;
    });
  }

  delete(data: any) {
    if (!data?.id) {
      console.error('ID არ არსებობს', data);
      return;
    }

    if (confirm(`დარწმუნებული ხარ რომ გინდა წაშლა: "${data.title}"?`)) {
      this.loadDeleteId = data.id;

      this.PostsService.delete(data.id).subscribe({
        next: () => {
          this.ToastrService.success('წარმატებით წაიშალა');
          this.getPageByItems();
          this.loadDeleteId = null;
        },
        error: (err: any) => {
          console.error(err);
          this.ToastrService.error('შეცდომა წაშლისას');
          this.loadDeleteId = null;
        }
      });
    }
  }

  toggleVisible(item: any) {
    if (!item?.id) return;
    if (item.__togglingVisible) return;

    item.__togglingVisible = true;

    // If your PostsService uses a different method name, adjust here.
    this.PostsService.toggleVisible(item.id, this.currentLang).subscribe({
      next: (res: any) => {
        const v = res?.visible ?? res?.data?.visible;
        if (v === 0 || v === 1) {
          item.visible = v;
        } else {
          // fallback if backend returns no visible
          item.visible = item.visible == 1 ? 0 : 1;
        }
        item.__togglingVisible = false;
      },
      error: (err: any) => {
        console.error(err);
        this.ToastrService.error('შეცდომა');
        item.__togglingVisible = false;
      }
    });
  }

  // Helpers for selected menu
  get selectedMenuType(): number {
    const sel = Number(this.selectedItem) || 0;
    const found = this.selectedItems.find(item => Number(item?.menu_page) === sel);
    return found?.menutype ?? 0;
  }

  get selectedMenuSource(): string {
    const sel = Number(this.selectedItem) || 0;
    const found = this.selectedItems.find(item => Number(item?.menu_page) === sel);
    return found?.source ?? '';
  }

  togglePin(item: any): void {
  if (!item || item.__togglingPin) {
    return;
  }

  const nextPin = item.pin == 1 ? 0 : 1;
  item.__togglingPin = true;

  this.http.post<any>(`${environment.apiUrl}admin/list/pin`, {
    id: item.id,
    pin: nextPin
  }).subscribe({
    next: (res) => {
      item.pin = typeof res?.pin !== 'undefined' ? Number(res.pin) : nextPin;
      item.__togglingPin = false;
    },
    error: (err) => {
      console.error('togglePin failed', err);
      item.__togglingPin = false;
    }
  });
}

}